package br.com.texeratx.boardgametimeapp.ui.screens.myclans

import br.com.texeratx.boardgametimeapp.data.model.clan.UserClanMembershipDTO

data class MyClansUiState(
    val isLoading: Boolean = false,
    val clans: List<UserClanMembershipDTO> = emptyList(),
    val error: String? = null,
    val userDisplayName: String? = null,
    val userImageUrl: String? = null,
)
